import { MakeCard } from 'src/types';
import Card from './Card';
import ivclass from '@invideoio/web-shared/Modules/IVClass';

interface CardsProps {
  cards: MakeCard[];
}

const Cards = (props: CardsProps) => {
  return (
    <div
      className={ivclass(
        'sm:iv-w-[340px] md:iv-w-[690px] lg:iv-w-[1080px] xl:iv-w-[1440px]',
        'iv-mx-auto',
        'iv-mt-75',
      )}
    >
      {props.cards.map((card, index) => (
        <Card key={index} card={card} />
      ))}
    </div>
  );
};

export default Cards;
